import PropTypes from "prop-types";
import { useState } from "react";
import { Button, Popper, Card, ClickAwayListener, Chip, Box, Autocomplete, TextField, Tooltip } from "@mui/material";
import { CustomAvatarGroup, CustomAvatar } from "../../../../reusable-components/custom-avatar";
import { editTicketData } from '../../../../redux/slices/tickets';
import { useDispatch, useSelector } from '../../../../redux/store';

OrderTicketRecipients.propTypes = {
  newUsers: PropTypes.array,
  setNewUsers: PropTypes.func,
  displayedTicket: PropTypes.number
}


export default function OrderTicketRecipients({newUsers, setNewUsers, displayedTicket}) {
  const dispatch = useDispatch();

  const [isUsersMenuOpen, setIsUsersMenuOpen] = useState(false);

  const { users: usersListById } = useSelector((state) => state.tickets.data.ticketInfoById[displayedTicket] || []);
  const {
    data: { users: usersList },
  } = useSelector((state) => state.tickets);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setIsUsersMenuOpen(true);
  };

  const handleClose = () => {
    setIsUsersMenuOpen(false);
    setAnchorEl(null);
  };

  const handleDelete = async (updatedUsers) => {
    if(updatedUsers.length >= 1){
      setNewUsers(updatedUsers)
      const value = updatedUsers.map(u => u.id);
      dispatch(editTicketData({ Id: displayedTicket, value, updateType: "Users" }));
    }
  };

    const handleUsers = (newValue) => {
      const updatedUsers = newValue.map((item) => {
        if (typeof item === 'string') {
          return { id: item, value: item };
        }
        return item;
      });
      setNewUsers(updatedUsers);
      if (displayedTicket !== 0)
      {
        dispatch(editTicketData({
          Id: displayedTicket,
          value: updatedUsers.map((user) => user.id),
          updateType: 'Users',
        }));
      }
  };

  const UsersList = () => <Box>
    <ClickAwayListener
      onClickAway={handleClose}
    >
      <Card
        sx={{
          p: 1,
          mt: 1,
          ml: 1,
          bgcolor: 'white',
          maxWidth: '200px',
        }}>
        {newUsers.map(u => <Chip
            disabled={newUsers.length === 1}
            key={u.id}
            label={u.value}
            sx={{m: '1px', fontSize: '12px'}}
            onDelete={() => handleDelete(newUsers.filter((user) => user.id !== u.id))}
            avatar={
              <CustomAvatar
                name={u?.value || u?.id}
                email={u?.id}
                sx={{ '&.MuiChip-avatar': { color: '#fff !important', } }}
              />}
            />
          )}
        <Box sx={{width: '100%', mr: 1, mt: 1}}>
          {' '}
          <Autocomplete
            size="small"
            multiple
            id="tags-outlined"
            options={usersList || usersListById || []}
            getOptionLabel={(option) => `${option.value} - ${option.id}`}
            value={newUsers}
            onChange={(event, newValue, reason) => {
              if (reason === 'removeOption' && newValue.length < 1) {
                return;
              }
              handleUsers(newValue);
            }}
            freeSolo
            disableClearable
            filterSelectedOptions
            renderTags={() => null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Type email"
                placeholder="Add user"
                autoComplete="off"
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                <Box
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '280px',
                  }}
                >
                  {option.value} - {option.id}
                </Box>
              </li>
            )}
            PopperComponent={(props) => (
              <Popper {...props} style={{ maxWidth: '300px'}} placement="bottom-start" />
            )}
          />
        </Box>
      </Card>
    </ClickAwayListener>
  </Box>

  return (
    <Box sx={{position: 'relative'}}>
      <CustomAvatarGroup
        size="small"
        sx={{
          justifyContent: 'left',
          opacity: newUsers?.length < 3 ? 1 : 0,
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      >
        {newUsers?.map((user, index) => (
          <CustomAvatar name={user?.value || user?.id} email={user?.id} key={index} />
        ))}
        <Tooltip title="Add user">
          <CustomAvatar
            name={'+'}
            showTooltip={false}
            onClick={handleOpen}
            sx={{
              cursor: 'pointer',
              backgroundColor: 'primary.main',
              width: '12px !important',
              height: '12px !important',
              my: 'auto',
              marginLeft: '-4px !important',
              zIndex: 1
            }}
          />
        </Tooltip>
      </CustomAvatarGroup>
      <Button
        id="composition-button"
        aria-controls={isUsersMenuOpen ? 'composition-menu' : undefined}
        aria-expanded={isUsersMenuOpen ? 'true' : undefined}
        aria-haspopup="true"
        onClick={isUsersMenuOpen ? handleClose : handleOpen}
        variant="contained"
        color="info"
        sx={{
          fontSize: '0.7rem !important',
          px: '6px !important',
          py: '5px !important',
          opacity: newUsers?.length >= 3 ? 1 : 0,
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: newUsers?.length < 3 ? 'none' : 'inherit'
        }}
      >
        {newUsers?.length} Recipients +
      </Button>

      <Popper open={isUsersMenuOpen} anchorEl={anchorEl} sx={{zIndex: 1000}}>
        <UsersList/>
      </Popper>
    </Box>
  ) 
}